import { getEmptyAddress } from "@jti/commerce";
import type { BillingAddressFieldValue } from "@jti/commerce-types";
import type { AddressStored } from "@jti/fe-common";

import type { FormFieldConfig } from "@checkout-v2/formFields/types/FormFieldConfig.types";
import type { FormFieldFactory } from "@checkout-v2/formFields/types/FormFieldFactory.types";

export type BillingAddressFieldConfig = FormFieldConfig<"billingAddress"> & {
  defaultAddress: AddressStored | null;
  emptyAddress: AddressStored;
};

type BillingAddressFieldGetDefaultValueOptions = {
  isBillingAddressVisibleForCheckout: boolean;
  userProfileAddresses: AddressStored[];
};

export const billingAddressFieldFactory: FormFieldFactory<
  "billingAddress",
  BillingAddressFieldValue,
  [boolean, AddressStored[], string, string],
  [BillingAddressFieldGetDefaultValueOptions],
  BillingAddressFieldConfig
> = {
  getDerivedConfig: (
    isBillingAddressVisibleForCheckout,
    userProfileAddresses,
    countryName,
    countryCode
  ): BillingAddressFieldConfig => {
    const emptyAddress = getEmptyAddress<AddressStored>({
      overrides: {
        countryCode,
        countryName,
      },
    });

    return {
      name: "billingAddress",
      isHidden: !isBillingAddressVisibleForCheckout,
      defaultAddress: userProfileAddresses.find((address) => address.isDefaultBilling) ?? emptyAddress,
      emptyAddress,
    };
  },
  getDefaultValue: ({ isBillingAddressVisibleForCheckout, userProfileAddresses }) => {
    if (!isBillingAddressVisibleForCheckout || !userProfileAddresses.length) {
      return null;
    }

    return userProfileAddresses.find((address) => address.isDefaultBilling) ?? null;
  },
};
